import { render, staticRenderFns } from "./GoodsFormDialog.vue?vue&type=template&id=5afd055e&scoped=true"
import script from "./GoodsFormDialog.vue?vue&type=script&lang=js"
export * from "./GoodsFormDialog.vue?vue&type=script&lang=js"
import style0 from "./GoodsFormDialog.vue?vue&type=style&index=0&id=5afd055e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd055e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afd055e')) {
      api.createRecord('5afd055e', component.options)
    } else {
      api.reload('5afd055e', component.options)
    }
    module.hot.accept("./GoodsFormDialog.vue?vue&type=template&id=5afd055e&scoped=true", function () {
      api.rerender('5afd055e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/superSubsidyV2/components/GoodsFormDialog.vue"
export default component.exports